import {
  Close,
  Done,
  SettingsSystemDaydreamTwoTone,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React from "react";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../../components/snackBar/snakbar";
import { API, graphqlOperation } from "aws-amplify";
import { updateCompanyCodeTranslation } from "../../../../graphql/mutations";
import {
  useCreateCompanyCodeTranslationArrayMutation,
  useCreateCompanyCodeTranslationMutation,
} from "../../../../redux/apis/getCompanyCodeTranslation.api";
import useSaveModalShortcut from "../../Components/useSaveModalShortcut";

function AddNewTdsTcsRow({
  rows,
  setRows,
  editedRows,
  setEditedRows,
  setAddEvent,
  tdsTcsID,
  optionType,
  ind,
  setData,
  setDataTDS,
  setOpen,
  data,
  totTaxAmt,
  Type,
}) {
  const [
    createUnit,
    {
      isLoading: isCreatingUnit,
      isError: isCreateUnitError,
      isSuccess: isCreateUnitSuccess,
      error: createUnitError,
    },
  ] = useCreateCompanyCodeTranslationArrayMutation();
  async function saveChanges() {
    try {
      let requireds = [];
      let isValid = true;
      let editedObj = { ...editedRows };
      if (editedObj.codeText === "") {
        isValid = false;
        requireds.push(
          optionType === "Add New TDS Option" ? "TDS Section" : "TCS Section"
        );
      }
      if (editedObj.codePercentage === "") {
        isValid = false;
        requireds.push(
          optionType === "Add New TDS Option"
            ? "TDS Percentage"
            : "TCS Percentage"
        );
      }
      let randomNumber = Math.floor(Math.random() * 100 + 1);
      let timeStamp = Math.floor(new Date().getTime() / 1000);
      const randomID = parseInt(
        randomNumber.toString() + timeStamp.toString().slice(3, 10),
        10
      );

      if (isValid) {
        if (tdsTcsID === "") {
          let obj = {
            codeorder: Number(randomID),
            expiredtimestamp: 0,
            codetext: editedRows?.codeText,
            codetype: optionType === "Add New TDS Option" ? 1 : 2,
            codevalue: Number(editedObj?.codePercentage),
            language: "",
            uqc: "",
            id: 0,
            is_active: 1,
          };
          addTdsTcs(obj);
        } else {
          let obj = {
            id: tdsTcsID,
            codeorder: Number(editedRows?.codeOrder),
            codetext: editedRows?.codeText,
            codetype: optionType === "Add New TDS Option" ? 1 : 2,
            codevalue: Number(editedObj?.codePercentage),
            language: "",
            uqc: "",
            expiredtimestamp: 0,
            is_active: 1,
          };

          editTdsTcs(obj);
        }
      } else {
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + " " + "are required");
        } else {
          showWarningSnackbar(`${requireds}` + " " + "is required");
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  }
  async function addTdsTcs(obj) {
    try {
      // const res = await API.graphql(
      const res = await createUnit({
        createCompanyCodeTranslationArrayInput: [obj],
      });
      const statusCode = res.data?.[0].statuscode;

      if (statusCode === "Success") {
        if (res.data?.[0]?.codetype === "2") {
          let tcsAmount = 0;
          if (totTaxAmt > 0) {
            tcsAmount =
              (Number(totTaxAmt) * Number(res.data?.[0]?.codevalue)) / 100;
            tcsAmount = Math.floor(Number(tcsAmount) * 100) / 100;
          }
          setData((prev) => ({
            ...prev,
            tcsOptions: res.data?.[0]?.codeorder,
            tcsPercent: res.data?.[0]?.codevalue,
            tcsAmount: tcsAmount,
            manualTCSAmt: 0,
            manualTcsFlag: 0,
          }));
        }
        if (res.data?.[0]?.codetype === "1") {
          let tdsAmount = 0;
          if (totTaxAmt > 0) {
            tdsAmount =
              (Number(totTaxAmt) * Number(res.data?.[0]?.codevalue)) / 100;
            tdsAmount = Math.floor(Number(tdsAmount) * 100) / 100;
          }
          if (Type === "Invoice") {
            setData((prev) => ({
              ...prev,
              tdsOptions: res.data?.[0]?.codeorder,
              tdsPercent: res.data?.[0]?.codevalue,
              tdsAmount: tdsAmount,
              manualTDSAmt: 0,
              manualTdsFlag: 0,
            }));
          } else {
            setDataTDS((prev) => ({
              ...prev,
              tdsOptions: res.data?.[0]?.codeorder,
              tdsPercent: res.data?.[0]?.codevalue,

              manualTDSAmt: 0,
              manualTdsFlag: 0,
            }));
          }
        }
        setOpen(false);

        showSuccessSnackbar(
          optionType === "Add New TDS Option"
            ? "Tds added successfully"
            : "Tcs added successfully"
        );
      } else {
        const errorMessage = res.error.message;
        console.log(errorMessage); // Output: "ERROR: Unit already exists !; SQLState: P0001"
        showErrorSnackbar(errorMessage);
      }
    } catch (err) {
      console.log("err", err);

      const rawMessage = err.errors[0].message;
      alert(rawMessage);

      // Step 2: Remove "RDSHttp:" prefix and parse the JSON string
      const parsedMessage = JSON.parse(rawMessage.replace("RDSHttp:", ""));
      showErrorSnackbar(parsedMessage);
    }
  }
  async function editTdsTcs(obj) {
    try {
      const res = await createUnit({
        createCompanyCodeTranslationArrayInput: [obj],
      });
      const statusCode = res.data?.[0].statuscode;
      console.log(res.data, "ffffffffff");
      if (statusCode === "Success") {
        if (Type === "Invoice") {
          if (
            res.data?.[0]?.codetype === "2" &&
            data?.tcsOptions == res.data?.[0]?.codeorder
          ) {
            let tcsAmount = 0;
            if (totTaxAmt > 0) {
              tcsAmount =
                (Number(totTaxAmt) * Number(res.data?.[0]?.codevalue)) / 100;
              tcsAmount = Math.floor(Number(tcsAmount) * 100) / 100;
            }
            console.log(res.data, "res.data");
            setData((prev) => ({
              ...prev,
              tcsOptions: res.data?.[0]?.codeorder,
              tcsPercent: res.data?.[0]?.codevalue,
              tcsAmount: tcsAmount,
              manualTCSAmt: 0,
              manualTcsFlag: 0,
            }));
          }
          if (
            res.data?.[0]?.codetype === "1" &&
            data?.tdsOptions == res.data?.[0]?.codeorder
          ) {
            let tdsAmount = 0;
            if (totTaxAmt > 0) {
              tdsAmount =
                (Number(totTaxAmt) * Number(res.data?.[0]?.codevalue)) / 100;
              tdsAmount = Math.floor(Number(tdsAmount) * 100) / 100;
            }
            setData((prev) => ({
              ...prev,
              tdsOptions: res.data?.[0]?.codeorder,
              tdsPercent: res.data?.[0]?.codevalue,
              tdsAmount: tdsAmount,
              manualTDSAmt: 0,
              manualTdsFlag: 0,
            }));
          }
          setOpen(false);
        } else {
          setDataTDS((prev) => ({
            ...prev,
            tdsOptions: res.data?.[0]?.codeorder,
            tdsPercent: res.data?.[0]?.codevalue,

            manualTDSAmt: 0,
            manualTdsFlag: 0,
          }));
        }
        // setDataTDS()
        showSuccessSnackbar(
          optionType === "Add New TDS Option"
            ? "Tds updated successfully"
            : "Tcs updated successfully"
        );
      } else {
        const errorMessage = res.error.message;
        console.log(errorMessage); // Output: "ERROR: Unit already exists !; SQLState: P0001"
        showErrorSnackbar(errorMessage);
      }
    } catch (err) {
      console.log("err", err);
      const errorMessage = JSON.parse(
        err.errors[0].message.replace("RDSHttp:", "")
      ).message;
      showErrorSnackbar(errorMessage);
    }
  }
useSaveModalShortcut(saveChanges)
  return (
    <TableRow
    className="TableCellBorder"
      sx={{
        height: "20px",
        ".MuiTableCell-root": {
          backgroundColor: "transparent !important",
        },
      }}
    >
      <TableCell>
        {/* {editedRows?.Id} */}
        {!isNaN(ind) ? ind + 1 : ""}
      </TableCell>
      <TableCell >
        <TextField
          id="codeText"
          name="codeText"
          size="small"
          autoFocus
          value={editedRows?.codeText}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "") {
              setEditedRows((prev) => ({
                ...prev,
                codeText: value,
              }));
            } else {
              setEditedRows((prev) => ({
                ...prev,
                codeText: value,
              }));
            }
          }}
          sx={{
            // "& fieldset": { border: "none" },
            width: 600, // Increase the width to 300px (or any size you need)
            minWidth: 500, // Ensure the minimum width is still 200px
          }}
        />
      </TableCell>
      {/* <TableCell>
        <TextField
          id="codeOrder"
          name="codeOrder"
          size="small"
          value={editedRows?.codeOrder}
          onChange={(e) => {
            const value = e.target.value;

            const alphanumericPattern = /^[a-zA-Z0-9]*$/;

            if (alphanumericPattern.test(value)) {
              setEditedRows((prev) => ({
                ...prev,
                codeOrder: value,
              }));
            }
          }}
          sx={
            {
              // "& fieldset": { border: "none" },
            }
          }
        />
      </TableCell> */}
      <TableCell >
        <TextField
          id="codePercentage"
          name="codePercentage"
          size="small"
          value={editedRows?.codePercentage}
          onChange={(e) => {
            const value = e.target.value;

            const numericPattern = /^\d*\.?\d{0,2}$/;

            if (numericPattern.test(value)) {
              const numericValue = Number(value);
              let maxValue = optionType === "Add New TDS Option" ? 99.999 : 100;

              if (numericValue <= maxValue) {
                setEditedRows((prev) => ({
                  ...prev,
                  codePercentage: value,
                }));
              }
            }
          }}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
          }}
          sx={
            {
              // "& fieldset": { border: "none" },
            }
          }
        />
      </TableCell>
      <TableCell align="center">
        <Box
          id="Action"
          tabIndex="0"
          sx={{
            width: 80,
            whiteSpace: "nowrap",
            position: "relative",
            left: "50%",
            transform: "translate(-50%)",
            outline: "none",
          }}
        >
          <Tooltip title={"Save"} placement="right" disableInteractive arrow>
            <IconButton
              id="Save"
              disableRipple
              aria-label="delete"
              sx={{
                margin: "0px 2px",
                padding: "5px",
                backgroundColor: "#83ff7b7a",
              }}
              onClick={saveChanges}
            >
              <Done sx={{ fontSize: "15px", color: "#34994f" }} />
            </IconButton>
          </Tooltip>

          <Tooltip title={"cancel"} placement="right" disableInteractive arrow>
            <IconButton
              id="cancel"
              onClick={(event) => {
                if (editedRows?.codeID === "") {
                  setAddEvent(false);
                } else {
                  let arr = [...rows];
                  let tempArr = arr.filter((ele, index) => {
                    if (ele.new !== true) {
                      if (ele.codeID == editedRows.codeID) {
                        ele.editable = false;
                        ele.new = false;
                      }
                      return ele;
                    }
                  });
                  setRows(tempArr);
                }
              }}
              aria-label="delete"
              sx={{
                margin: "0px 2px",
                padding: "5px",
                backgroundColor: "#fbc7c78c",
              }}
            >
              <Close sx={{ fontSize: "15px", color: "#eb6a6a" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default AddNewTdsTcsRow;
